import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ErrorPage, RootLayout } from '.';
import Home from 'pages/Home/Home';
import ReviewPDFWrapper from 'pages/ReviewPDF/ReviewPDFWrapper';
import { Unauthorized } from 'pages';
// import { Compare } from 'pages/Compare';
// import { ImageComparison } from 'components/ImageComparison';

const AppRouter = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <RootLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: 'review-pdf',
          element: <ReviewPDFWrapper />,
        },
        {
          path: 'unauthorized', // This Unauthorized Page is for unauthorized access
          element: <Unauthorized />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppRouter;
